module.exports = global["$"] = require("-!C:\\actions_runner\\_work\\escapia-ownerportal\\escapia-ownerportal\\Solutions\\op\\Owner.Portal\\node_modules\\expose-loader\\index.js?jQuery!.\\jquery.js");


//////////////////
// WEBPACK FOOTER
// ./~/jquery/dist/jquery.js
// module id = 33
// module chunks = 0